/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiCursorAClickIcon16Light } from './UiCursorAClickIcon16Light';
import { UiCursorAClickIcon16Regular } from './UiCursorAClickIcon16Regular';
import { UiCursorAClickIcon16Solid } from './UiCursorAClickIcon16Solid';
import { UiCursorAClickIcon20Light } from './UiCursorAClickIcon20Light';
import { UiCursorAClickIcon20Regular } from './UiCursorAClickIcon20Regular';
import { UiCursorAClickIcon20Solid } from './UiCursorAClickIcon20Solid';
import { UiCursorAClickIcon24Regular } from './UiCursorAClickIcon24Regular';
import { UiCursorAClickIcon24Solid } from './UiCursorAClickIcon24Solid';
import { UiCursorAClickIcon32Regular } from './UiCursorAClickIcon32Regular';
import { UiCursorAClickIcon64Regular } from './UiCursorAClickIcon64Regular';
var sizes = {
    16: {
        light: UiCursorAClickIcon16Light,
        regular: UiCursorAClickIcon16Regular,
        solid: UiCursorAClickIcon16Solid,
    },
    20: {
        light: UiCursorAClickIcon20Light,
        regular: UiCursorAClickIcon20Regular,
        solid: UiCursorAClickIcon20Solid,
    },
    24: {
        regular: UiCursorAClickIcon24Regular,
        solid: UiCursorAClickIcon24Solid,
    },
    32: {
        regular: UiCursorAClickIcon32Regular,
    },
    64: {
        regular: UiCursorAClickIcon64Regular,
    },
};
export var UiCursorAClickIcon = forwardRef('UiCursorAClickIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
